export default {
  en: {
    specialOffer: 'Special Offer'
  },
  th: {
    specialOffer: 'ข้อเสนอพิเศษ'
  }
}
